/* VitaGreen Galerie-Zoom (Heinrich 04.10.2026).
   Maus: Hover-Zoom. Der Bildbereich unter dem Zeiger erscheint vergrößert im selben Rahmen, ohne Klick.
   Touch: Antippen öffnet das Bild groß als Overlay, Antippen irgendwo schließt es wieder.
   Die große Bildfassung wird erst bei Bedarf geladen (erstes Überfahren bzw. Antippen), der Zoom läuft
   ausschließlich über transform. Klick mit der Maus öffnet weiter Horizons Zoom-Dialog. */

const SLIDE = '.product-media-container--zoomable.product-media-container--image';
// Heinrich 07.10.2026: Zusatz-Zoom um 30 % reduziert, 1 + (2,5 - 1) × 0,7 = 2,05 (vorher 2.5)
const SCALE = 2.05;
const HI_RES = 2048;

const CSS = `
.vgp-hz { position: absolute; overflow: hidden; pointer-events: none; z-index: 1; opacity: 0; transition: opacity .15s ease; }
.vgp-hz.is-on { opacity: 1; }
.vgp-hz img { position: absolute; inset: 0; width: 100%; height: 100%; max-width: none; object-fit: contain; transform-origin: 0 0; will-change: transform; }
${SLIDE} .product-media { position: relative; }
${SLIDE}.vgp-hz-active .product-media__image { opacity: 0; }
@media (hover: hover) and (pointer: fine) { ${SLIDE}:not(.dialog-zoomed-gallery *) { cursor: zoom-in; } }
.vgp-tz { position: fixed; inset: 0; width: 100%; height: 100%; max-width: none; max-height: none; margin: 0; padding: 0; border: 0; background: #faf9f5; touch-action: none; opacity: 0; transition: opacity .18s ease; }
.vgp-tz[open] { display: grid; place-items: center; }
.vgp-tz.is-on { opacity: 1; }
.vgp-tz::backdrop { background: transparent; }
.vgp-tz img { width: 100%; height: 100%; object-fit: contain; transform: scale(.94); transition: transform .18s ease; }
.vgp-tz.is-on img { transform: none; }
.vgp-tz__close { position: absolute; top: max(12px, env(safe-area-inset-top)); right: 12px; display: grid; place-items: center; width: 44px; height: 44px; border: 1px solid #d6d9d0; border-radius: 999px; background: #fff; color: #23271f; font-size: 1.5rem; line-height: 1; }
.vgp-tz__hint { position: absolute; bottom: max(16px, env(safe-area-inset-bottom)); left: 0; right: 0; margin: 0; text-align: center; font-size: .8125rem; color: #464b41; }
@media (prefers-reduced-motion: reduce) { .vgp-hz, .vgp-tz, .vgp-tz img { transition: none; } }
`;

let styled = false;
function style() {
  if (styled) return;
  styled = true;
  const s = document.createElement('style');
  s.textContent = CSS;
  document.head.appendChild(s);
}

const slideOf = (el) => {
  const s = el instanceof Element ? el.closest(SLIDE) : null;
  return s && !s.closest('.dialog-zoomed-gallery') ? s : null;
};

// Shopify-CDN liefert jede Breite bis zur Originalgröße; nur der width-Parameter wird ersetzt.
function sized(src, w) {
  try {
    const u = new URL(src, location.href);
    u.searchParams.set('width', String(w));
    return u.href;
  } catch {
    return src;
  }
}

const loaded = new Map();
function load(url) {
  if (!loaded.has(url)) {
    const i = new Image();
    i.src = url;
    loaded.set(url, i.decode().then(() => url));
  }
  return loaded.get(url);
}

/* ---------------------------------------------------------------- Maus: Hover-Zoom */
let active = null;
let lens = null;
let pos = null;
let frame = 0;

function paint() {
  frame = 0;
  if (!active || !pos) return;
  const r = lens.getBoundingClientRect();
  const px = Math.min(1, Math.max(0, (pos.x - r.left) / r.width));
  const py = Math.min(1, Math.max(0, (pos.y - r.top) / r.height));
  lens.firstChild.style.transform =
    `translate3d(${-px * (SCALE - 1) * r.width}px, ${-py * (SCALE - 1) * r.height}px, 0) scale(${SCALE})`;
}

function start(slide) {
  const img = slide.querySelector('.product-media__image');
  const box = slide.querySelector('.product-media');
  if (!img || !box) return;
  style();
  active = slide;
  lens = box.querySelector(':scope > .vgp-hz');
  if (!lens) {
    lens = document.createElement('div');
    lens.className = 'vgp-hz';
    lens.setAttribute('aria-hidden', 'true');
    lens.appendChild(document.createElement('img')).alt = '';
    box.appendChild(lens);
  }
  // Die Lupe deckt genau die Bildfläche ab, nicht den ganzen Folienrahmen.
  const b = box.getBoundingClientRect();
  const i = img.getBoundingClientRect();
  Object.assign(lens.style, { left: `${i.left - b.left}px`, top: `${i.top - b.top}px`, width: `${i.width}px`, height: `${i.height}px` });
  const zoom = lens.firstChild;
  const base = img.currentSrc || img.src;
  const big = sized(base, HI_RES);
  if (zoom.dataset.src !== big) {
    zoom.dataset.src = big;
    zoom.src = base;
    load(big).then((u) => { if (zoom.dataset.src === u) zoom.src = u; }).catch(() => {});
  }
  slide.classList.add('vgp-hz-active');
  lens.classList.add('is-on');
}

function stop() {
  if (!active) return;
  active.classList.remove('vgp-hz-active');
  if (lens) lens.classList.remove('is-on');
  active = null;
  pos = null;
}

document.addEventListener('pointermove', (e) => {
  if (e.pointerType !== 'mouse') return;
  const s = slideOf(e.target);
  if (s !== active) {
    stop();
    if (s) start(s);
  }
  if (!active) return;
  pos = { x: e.clientX, y: e.clientY };
  if (!frame) frame = requestAnimationFrame(paint);
}, { passive: true });

document.addEventListener('pointerout', (e) => {
  if (active && !(e.relatedTarget instanceof Node && active.contains(e.relatedTarget))) stop();
}, { passive: true });
window.addEventListener('scroll', stop, { passive: true });
window.addEventListener('blur', stop);

/* ---------------------------------------------------------------- Touch: Antippen zum Vergrößern */
let lastPointer = 'mouse';
document.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType; }, { capture: true, passive: true });

let dlg = null;
function overlay() {
  if (dlg) return dlg;
  style();
  dlg = document.createElement('dialog');
  dlg.className = 'vgp-tz';
  dlg.setAttribute('aria-label', 'Produktbild vergrößert');
  dlg.innerHTML = '<img alt=""><button type="button" class="vgp-tz__close" aria-label="Schließen">×</button><p class="vgp-tz__hint" aria-hidden="true">Zum Schließen tippen</p>';
  // Jeder Tipp auf das Overlay schließt es, egal wo.
  dlg.addEventListener('click', () => dlg.close());
  dlg.addEventListener('close', () => {
    dlg.classList.remove('is-on');
    document.documentElement.style.removeProperty('overflow');
  });
  document.body.appendChild(dlg);
  return dlg;
}

function enlarge(slide) {
  const img = slide.querySelector('.product-media__image');
  if (!img) return;
  const d = overlay();
  const view = d.querySelector('img');
  const base = img.currentSrc || img.src;
  const w = Math.min(HI_RES, Math.ceil(Math.max(innerWidth, innerHeight) * (devicePixelRatio || 1)));
  const big = sized(base, w);
  view.alt = img.alt || '';
  view.dataset.src = big;
  view.src = base;
  load(big).then((u) => { if (view.dataset.src === u) view.src = u; }).catch(() => {});
  document.documentElement.style.overflow = 'hidden';
  d.showModal();
  requestAnimationFrame(() => d.classList.add('is-on'));
}

// Capture-Phase auf window: läuft vor Horizons on:click-Verteiler (component.js, Capture auf document),
// damit bei Touch nur das Overlay aufgeht und nicht zusätzlich der Zoom-Dialog.
window.addEventListener('click', (e) => {
  if (lastPointer !== 'touch' && lastPointer !== 'pen') return;
  const s = slideOf(e.target);
  if (!s) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  enlarge(s);
}, { capture: true });
